<template>
  <div class="mr-3">
    <v-progress-circular
      v-if="isRunning"
      indeterminate
      size="15"
      width="2"
      color="accent"
    />

    <v-icon v-else-if="status === 'success'" color="success">
      check_circle
    </v-icon>

    <v-icon v-else-if="status === 'error'" color="error">
      error
    </v-icon>

    <v-icon
      v-if="!hasChildren && status === 'warning'"
      @click.stop="$emit('selectItem')"
    >
      list
    </v-icon>

    <v-icon v-if="status === 'warning'" color="warning">
      warning
    </v-icon>
  </div>
</template>

<script>
export default {
  name: "ValidationState",

  props: {
    item: {
      type: Object,
      required: true
    }
  },

  computed: {
    hasChildren() {
      return this.item.hasOwnProperty("validations");
    },

    isRunning() {
      return this.item.state.running;
    },

    status() {
      return this.item.state.result;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Home/Content/Tabs/Validations/ValidationSelection/ValidationState.vue